// DEBT-VITA™ — Helpers API
// Wrappers axios pour les endpoints /api/debt/*
import { api } from "@/lib/api";

export async function getDebtPrefill(projectId) {
  const { data } = await api.get(`/debt/${projectId}/prefill`);
  return data?.data ?? null;
}

export async function getDebtParameters(projectId) {
  const { data } = await api.get(`/debt/${projectId}/parameters`);
  return data?.data ?? null;
}

export async function saveDebtParameters(projectId, payload) {
  const { data } = await api.put(`/debt/${projectId}/parameters`, payload);
  return data?.data ?? null;
}

export async function deleteDebtParameters(projectId) {
  const { data } = await api.delete(`/debt/${projectId}/parameters`);
  return data?.data ?? null;
}

export async function calculateDebtVita(projectId, contributorProfileId, save = true) {
  const { data } = await api.post(`/debt/${projectId}/calculate`, {
    contributor_profile_id: contributorProfileId,
    save,
  });
  return data?.data ?? null;
}

export async function getLatestDebtResult(projectId) {
  const { data } = await api.get(`/debt/${projectId}/results/latest`);
  return data?.data ?? null;
}

export async function listProjectProfiles(projectId) {
  const { data } = await api.get(`/projects/${projectId}/contributor-profiles`);
  return data?.data ?? [];
}

export async function listDebtProjectsSummary() {
  const { data } = await api.get(`/debt/projects-summary`);
  return data?.data ?? [];
}

export async function generateDebtNarrative(projectId, forceRegenerate = false) {
  const { data } = await api.post(
    `/debt/${projectId}/narrative${forceRegenerate ? "?force_regenerate=true" : ""}`,
    {}
  );
  return data?.data ?? null;
}

export async function clearDebtNarrative(projectId) {
  const { data } = await api.delete(`/debt/${projectId}/narrative`);
  return data?.data ?? null;
}

// Liste fixe des types de créancier (alignée backend regex).
export const CREDITOR_TYPES = [
  { value: "MULTILATERAL", label: "Multilatéral (FMI, Banque Mondiale…)" },
  { value: "BILATERAL", label: "Bilatéral (État souverain)" },
  { value: "COMMERCIAL", label: "Commercial (banques, marchés)" },
  { value: "DOMESTIC", label: "Intérieur (national)" },
];

export const CURRENCY_OPTIONS = ["UM", "USD", "EUR", "CNY", "XOF", "MAD", "DZD", "TND", "GBP"];

// Palette officielle DEBT-VITA™
export const DEBT_COLORS = {
  blue: "#1A3C5E",
  gold: "#C9A84C",
  red: "#C0392B",
  green: "#27AE60",
  orange: "#E67E22",
  yellow: "#F1C40F",
  black: "#0F1419",
};

